import React from 'react'

const getLabelProps = (() => {
	const propsDict = {
		labelMinWidth: 'minWidth',
		labelTextAlign: 'textAlign',
		labelWidth: 'width'
	}
	return (props = {}) => {
		const ret = Object.entries(props).reduce((sum, [key, value]) => (propsDict[key] && (sum[propsDict[key]] = value, delete props[key]), sum), {})
		ret.textAlign && ret.textAlign == 'right' && (ret.justifyContent = 'flex-end')
		return ret
	}
})()

const genClassName = ui => ['t-input-wrapper'].concat(ui && ui.split(' ').filter(o => o).map(v => `t-input-${v}`) || []).join(' ')
const getLabelPromptTip = prompt => {
	if (!prompt) return {}
	prompt = [].concat(prompt).join('<br>')
	return {
		'data-qtip': prompt,
		// 'data-qdismissDelay': 0,
		// 'data-qallowOver': true,
		// 'data-qhideDelay': 100,
		// 'data-qshowDelay': 100,
		'data-qanchor': true,
		// 'data-qquickShowInterval': 50
	}
}
const InputWrapper = ({ fieldID, children, label, labelAlign, disabled, prompt, required, ui, noLocale, ...props }) => {
	const labelProps = getLabelProps(props)
	labelAlign == 'top' && (props.flexDirection = 'column')
	labelProps.display = label ? 'flex' : 'none'
	!noLocale && (label = Tyan.t(label, 'label'))
	return <div id={`inputwrapper-${fieldID}`} className={genClassName(ui)} style={props}>
		<label className='t-input-label' style={labelProps} {...{ disabled, required }} >
			<span className='t-input-label-prompt' {...getLabelPromptTip(prompt)} />
			<span className='t-input-label-element' style={{ display: 'flex', flexDirection: 'row' }} dangerouslySetInnerHTML={{ __html: label }} />
			{/* {label} */}
		</label>
		{children}
	</div >
}

export default InputWrapper